const getFeatureId = feature =>
    feature.id ??
    `${feature.linear_location[0].road}-${feature.linear_location[0].start}-${feature.linear_location[0].end}`

export const getUniqueFeaturesById = features => {
    const seen = new Set()
    return features.filter(feature => {
        const id = getFeatureId(feature)
        if (seen.has(id)) {
            return false
        }
        seen.add(id)
        return true
    })
}